import { FC, ReactNode } from 'react';
import { cn } from '@new/lib';

interface SectionHeadingProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export const SectionHeading: FC<SectionHeadingProps> = ({
  title,
  description,
  actions,
  className,
}) => (
  <div className={cn('border-b border-(--neutral-black-NB200)', className)}>
    <div className="flex items-center justify-between gap-4">
      <div className="min-w-0">
        <h3 className="m-0! text-base font-semibold text-(--neutral-black-NB1000)!">{title}</h3>
        {description ? (
          <p className="m-0! mt-1 text-sm text-(--neutral-black-NB600)!">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </div>
  </div>
);
